import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CircleNotchIcon } from "@phosphor-icons/react";

const Loader = () => (
  <div className="h-screen w-screen flex items-center justify-center bg-zinc-950">
    <CircleNotchIcon className="h-6 w-6 animate-spin text-cyan-500" />
  </div>
);

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
